import styled from "styled-components"

import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'
import { Tooltip } from 'ggx-componentlibrary/components/tooltip/tooltip.component'
import { ContentBox } from 'ggx-componentlibrary/components/tooltip/tooltip.component.styles'

const  MerchantOrderNoteFormWrapper = styled.div`
  margin-top: ${SPACING.L};
`

const StyledTooltip = styled(Tooltip)`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  ${ContentBox} {
    pointer-events: none;
    align-self: center;
  }
`

const StyledFlexBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

const StyledSmallText = styled(SmallText)`
  margin: 0 -${SPACING.XXS} 0 ${SPACING.XXS};
`

const StyledSmallTextNoWrap = styled(SmallText)`
  margin: 0;
  white-space: nowrap;
`

export {  MerchantOrderNoteFormWrapper, StyledTooltip, StyledSmallText, StyledSmallTextNoWrap }
